// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { B200, N20A } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var UnreadIndicatorWrapper = styled.button({
  // Reset default btn styles
  border: '1px solid transparent',
  padding: 0,
  backgroundColor: 'transparent',
  pointerEvents: 'all',
  zIndex: 1,
  height: '32px',
  width: '32px',
  borderRadius: '50%',
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  outline: 'none',
  '&:hover, &:focus': {
    cursor: 'pointer',
    backgroundColor: "var(--ds-background-neutral-subtle-hovered, ".concat(N20A, ")")
  },
  '&:focus': {
    boxShadow: "".concat("var(--ds-border-focused, ".concat(B200, ")"), " 0 0 0 2px")
  },
  '&:active': {
    backgroundColor: "var(--ds-background-selected, rgba(179,212,255,0.6))"
  }
});